<script>
import { createEventDispatcher } from 'svelte'

const dispatch = createEventDispatcher()

const MIN_DONATION_AMOUNT = 5

function validateDonationAmount(input) {
	const intAmount = parseInt(input, 10)
	if (intAmount < MIN_DONATION_AMOUNT) {
		return MIN_DONATION_AMOUNT
	}

	return intAmount
}

export let defaultAmount = 50
export let amountInput = ''
export let frequency = 'monthly'

let name = ''
let address = ''

let errorMessage = null
let message = null

$: currentDonationAmount = amountInput ? validateDonationAmount(amountInput) : defaultAmount

const validateAmount = () => {
	if (amountInput !== currentDonationAmount.toString()) {
		amountInput = validateDonationAmount(amountInput)
	}
}

const handleSubmit = (event) => {
	event.preventDefault()

	dispatch('openCheckout', {
		name: 'Dominion Institute',
		description: `${currentDonationAmount}$ donation`,
		amount: currentDonationAmount * 100,
		dollars: currentDonationAmount,
		frequency,
		meta: {
			name,
			address,
		}
	})
}

export const handleError = (error) => {
	errorMessage = error ? (error.message || error.toString()) : 'Error!'
	message = ''
}

export const handleToken = ({ email, id, dollars, frequency }) => {
	message = 'Processing donation...'

	dispatch('submitDonation', {
		email,
		token: id,
		dollars,
		frequency,
		name,
		address,
	})
}

export const handleDonationPostResponse = response => {
	message = response.message
}
</script>

<form on:submit="{event => handleSubmit(event)}">
	<div class="group">
		<label>
			<span>Amount (USD)</span>
			<input
				type="number"
				class="field"
				data-is-empty="{amountInput === ''}"
				placeholder="{defaultAmount}"
				bind:value="{amountInput}"
				on:change="{validateAmount}"
			>
		</label>
		<label>
			<span>Monthly</span>
			<input
				type="radio"
				bind:group="{frequency}"
				value="monthly"
			>
		</label>
		<label>
			<span>Once</span>
			<input
				type="radio"
				bind:group="{frequency}"
				value="once"
			>
		</label>
	</div>
	<div class="group">
		<p>
			You don't need to give your name and address unless you would like to receive a receipt for your tax-deductible donation.
		</p>
		<label>
			<span>Name</span>
			<input
				type=text
				class=field
				bind:value={name}
			>
		</label>
		<label class=tall-field>
			<span>Address</span>
			<textarea
				class=field
				bind:value={address}
			/>
		</label>
	</div>
	<button type="submit">
		Donate ${currentDonationAmount} {frequency}
	</button>
	<div class="outcome">
		{#if errorMessage}
		<div class="error">
			{errorMessage}
		</div>
		{/if}
		{#if message}
		<div class="message">
			{message}
		</div>
		{/if}
	</div>
</form>

<style>

* {
	font-family: "Helvetica Neue", Helvetica;
	font-size: 15px;
	font-variant: normal;
	padding: 0;
	margin: 0;
}

form {
	width: 300px;
	margin: 10px auto;

	--brand-color: #00AEEF;
}

.group {
	background: white;
	box-shadow: 0 7px 14px 0 rgba(49,49,93,0.10),
	            0 3px 6px 0 rgba(0,0,0,0.08);
	border-radius: 4px;
	margin-bottom: 20px;
}

label {
	position: relative;
	color: #8898AA;
	font-weight: 300;
	height: 40px;
	line-height: 40px;
	display: block;
}

.group label:not(:last-child) {
	border-bottom: 1px solid #F0F5FA;
}

label > span {
	width: 40%;
	text-align: right;
	float: left;
}

input {
	padding-right: 10px;
	padding-left: 10px;
	width: 55%;
	height: 40px;
	float: right;
	border: 0;
	color: #31325F;
}

label.tall-field, .tall-field textarea {
	height: 80px;
}

textarea {
	font-size: 14px;

	padding-right: 10px;
	padding-left: 10px;
	width: 55%;
	float: right;

	white-space: pre;
	overflow: auto;
}

input[type=radio] {
	height: 18px;
	margin-top: 12px;
}

.field {
	font-weight: 300;
	outline: none;
	cursor: text;

	border: 1px solid lightgray;
	border-radius: 2px;
	box-sizing: border-box;
}

.field::-webkit-input-placeholder { color: #CFD7E0; }
.field::-moz-placeholder { color: #CFD7E0; }
.field:-ms-input-placeholder { color: #CFD7E0; }

button {
	display: block;
	background: var(--brand-color);
	color: black;
	box-shadow: 0 7px 14px 0 rgba(49,49,93,0.10),
	            0 3px 6px 0 rgba(0,0,0,0.08);
	border-radius: 4px;
	border: 0;
	margin-top: 20px;
	font-size: 15px;
	font-weight: 400;
	width: 100%;
	height: 40px;
	line-height: 38px;
	outline: none;

	cursor: pointer;
}

button:focus {
	background: #555ABF;
}

button:active {
	background: #43458B;
}

.outcome {
	width: 100%;
	padding-top: 8px;
	min-height: 24px;
	text-align: center;
}

.message, .error {
	font-size: 13px;
	display: inline;
}

.error {
	color: #E4584C;
}

p {
	padding: 1rem;
	font-size: 12px;
	color: gray;
}

</style>
